// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"92":"1b93b923","262":"1b93b923","688":"1b93b923","733":"1b93b923","941":"1b93b923"}[chunkId] + ".chunk.css";
};